import {
    CalendarImportLinkRel,
    CreateOrderFlowType,
    AvailableModules,
} from "../../createOrderTypes"
import { useCreateOrderFormConfig } from "../../mainForm/CreateOrderFormContext"
import { FinalSuccessDialogContent } from "./FinalSuccessDialogContent"
import { CreateUpdateBookingResponse } from "../../createOrderApi"
import { OrderFormStatus } from "../../mainForm/helpers"
import { CreateOrderType } from "../../helpers"

type FinalSuccessDialogResourcesProps = Readonly<{
    orderDetails: CreateUpdateBookingResponse
    onClose: (shouldRefresh?: boolean) => void
    handleCloseMainDialog: () => void
    handleOpenMeetingService: (type: CreateOrderType) => void
    orderFormStatusRef: React.MutableRefObject<OrderFormStatus>
    resetBookingToInitialState: () => void
    availableModules: AvailableModules
    isNewOrder: boolean
}>

export function FinalSuccessDialogResources({
    orderDetails,
    onClose,
    handleCloseMainDialog,
    handleOpenMeetingService,
    orderFormStatusRef,
    resetBookingToInitialState,
    availableModules,
    isNewOrder,
}: FinalSuccessDialogResourcesProps) {
    const { isFullInitOrder, meetingServiceId } = orderFormStatusRef.current
    const { flowConfig } = useCreateOrderFormConfig()
    const isOutlookFlow = flowConfig?.flow === CreateOrderFlowType.OUTLOOK
    const { order, calendarImportLinks } = orderDetails

    const handleAddMeetingService = () => {
        onClose(false)
        handleOpenMeetingService(CreateOrderType.MEETING_SERVICE)
    }
    const handleNewOrder = () => {
        resetBookingToInitialState()
        onClose()
    }

    const icsAppointmentLink = Array.isArray(calendarImportLinks)
        ? calendarImportLinks.find((link) => link.rel === CalendarImportLinkRel.ICS_APPOINTMENT)?.href
        : undefined

    return (
        <FinalSuccessDialogContent
            open={!!order}
            onClose={onClose}
            orderType={CreateOrderType.RESOURCE_BOOKING}
            icsAppointmentLink={icsAppointmentLink}
            handleFinish={handleCloseMainDialog}
            handleAddMeetingService={availableModules.isCateringActive ? handleAddMeetingService : undefined}
            handleNewOrder={!isOutlookFlow ? handleNewOrder : undefined}
            isUpdate={isFullInitOrder || !!meetingServiceId}
            isOutlookFlow={isOutlookFlow}
            orderId={isNewOrder ? order?.id : undefined}
        />
    )
}
